import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SpinnerIcon } from '../../../../../components/Commons/SpinnerIcon/styles';
import { ApplicationState } from '../../../../../store';
import { ICustomer } from '../../../../../store/ducks/customers/types';
import { loadLastOrders } from '../../../../../store/ducks/long-steel-order-item-search/actions';
import { sendTagging } from '../../../../../store/ducks/tagging/actions';
import { getTaggingInformationScreen } from '../../../../../utils/Tagging';
import LastOrderList from '../LastOrderList';
import { Container } from './styles';

interface RepeatOrderProps {
  customerId: string;
}

const RepeatOrder: React.FC<RepeatOrderProps> = ({ customerId }) => {
  const dispatch = useDispatch();

  const customers = useSelector((state: ApplicationState) => state.customers);

  const lastOrdersState = useSelector(
    (state: ApplicationState) => state.longSteelOrderItemSearch.lastOrdersState
  );

  const getCustomer = (): ICustomer => {
    return customers.customers.find(
      (customer) => customer.customerId === customerId
    ) as ICustomer;
  };

  useEffect(() => {
    if (
      customerId !== '' &&
      !lastOrdersState.loading &&
      lastOrdersState.customerId !== customerId
    ) {
      dispatch(loadLastOrders(customerId));
    }
  });

  const orderItemSearch = useSelector(
    (state: ApplicationState) => state.longSteelOrderItemSearch
  );

  const { screenName = '' } = getTaggingInformationScreen(
    document.location.pathname
  );

  useEffect(() => {
    dispatch(
      sendTagging({
        page: document.location.pathname,
        screenName,
        event: 'page_view'
      })
    );
  }, []);

  return (
    <Container>
      {orderItemSearch.lastOrdersState.loading ? (
        <>
          <h3>Buscando últimos pedidos </h3>
          <SpinnerIcon />
        </>
      ) : (
        <>
          <h3>Últimos pedidos encontrados:</h3>
          <LastOrderList
            items={customerId !== '' ? lastOrdersState.lastOrders : []}
            customerState={getCustomer()?.locality.state || ''}
          ></LastOrderList>
        </>
      )}
    </Container>
  );
};

export default RepeatOrder;
